var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('div',{staticClass:"default-display",class:_vm.$style['display']},[_vm._v(" "+_vm._s(_vm.value)+" ")]),_c('span',{class:_vm.$style['answer']},[_vm._v(_vm._s(_vm.answer))])])}
var staticRenderFns = []

export { render, staticRenderFns }